/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const aboutUsSectionStyle = {
  centeredText: {
    textAlign: "center",
  },
  subtitle: {
    marginTop: "2rem",
    textAlign: "center",
  },
};

export default aboutUsSectionStyle;
